// extracted by mini-css-extract-plugin
export default {"navigations-wrapper":"NavigationCards_navigations-wrapper__zgy3m"};